import VSelectCardTypeId from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardTypeId', VSelectCardTypeId),
};
